// src/pages/ItemStock/ItemStockThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getStockReportApi } from "../../apiservice/inventory"; // adjust path

export const fetchItemStockReport = createAsyncThunk(
  "itemStock/fetchReport",
  async (filters, { rejectWithValue }) => {
    try {
      const payload = {
        categoryId:
          filters.filterType === "By Category" ? filters.categoryId : null,
        groupId: filters.filterType === "By Group" ? filters.groupId : null,
        itemId: filters.filterType === "By Item" ? filters.itemId : null,
        warehouseId:
          filters.filterType === "By Warehouse" ? filters.warehouseId : null,
      };
      const res = await getStockReportApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
